<div class="dialog-container">
  <div class="instructions-section bg-slate-50 dark:bg-slate-900/50">
    <div class="p-6">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
          <mat-icon class="icon-size-5 text-blue-600 dark:text-blue-400"
            [svgIcon]="'tabler_outline:file-certificate'"></mat-icon>
        </div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">Jak wygenerować certyfikat KSeF</h3>
      </div>

      <ol class="instruction-list text-gray-700 dark:text-gray-300">
        <li class="instruction-item">
          <p class="instruction-title">1. Zaloguj się do portalu KSeF</p>
          <p class="instruction-copy text-gray-600 dark:text-gray-400">Wejdź na <a href="https://ap.ksef.mf.gov.pl/web/"
              target="_blank" class="text-primary-600 underline">portal KSeF</a> i zaloguj się Profilem Zaufanym lub
            certyfikatem
            kwalifikowanym.</p>
          <div
            class="instruction-image-wrap rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
            <img src="assets/images/ksef/ksef_logowanie.png" alt="Logowanie do portalu KSeF"
              class="instruction-image rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
          </div>
        </li>
        <li class="instruction-item">
          <p class="instruction-title">2. Wnioskuj o certyfikat</p>
          <p class="instruction-copy text-gray-600 dark:text-gray-400">Naciśnij wnioskuj o certyfikat i wypełnij
            formularz zgodnie z
            instrukcjami. Zapamiętaj 15 znakowe hasło klucza prywatnego i upewnij się, że dobrze je przepisałeś,
            ponieważ
            będziesz musiał je wprowadzić też w naszym systemie w polu "Hasło klucza prywatnego".</p>
          <div
            class="instruction-image-wrap rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
            <img src="assets/images/ksef/generowanie_klucza.jpg" alt="Generowanie klucza w portalu KSeF"
              class="instruction-image rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
          </div>
        </li>
        <li class="instruction-item">
          <p class="instruction-title">3. Pobierz klucz prywatny i wyślij wniosek</p>
          <p class="instruction-copy text-gray-600 dark:text-gray-400">Po kliknięciu "Generuj", automatycznie zostanie
            pobrany klucz
            prywatny (z rozszerzeniem .pem) &mdash; zapisz go na komputerze. Następnie wybierz przeznaczenie
            certyfikatu: <span class="instruction-emphasis">Uwierzytelnianie w systemie KSeF</span>. W polu "Certyfikat ważny od" upewnij się, że
            jest wprowadzona dzisiejsza data. Kliknij "Wyślij wniosek o wydanie certyfikatu".</p>
          <div
            class="instruction-image-wrap rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
            <img src="assets/images/ksef/pobierz_klucz_prywatny.jpg" alt="Pobieranie klucza prywatnego"
              class="instruction-image rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
          </div>
        </li>
        <li class="instruction-item">
          <p class="instruction-title">4. Pobierz certyfikat i wgraj pliki</p>
          <p class="instruction-copy text-gray-600 dark:text-gray-400">Pobierz plik certyfikatu z portalu KSeF. Załącz
            pliki w
            Fakturnia.pl, czyli plik certyfikatu KSeF, plik klucza prywatnego oraz hasło klucza prywatnego. Następnie
            naciśnij "Zapisz certyfikat", a połączenie zostanie automatycznie zapisane. Certyfikat KSeF jest ważny przez
            2 lata.</p>
          <div
            class="instruction-image-wrap rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 text-center">
            <img src="assets/images/ksef/pobierz_certyfikat.jpg" alt="Pobieranie certyfikatu"
              class="instruction-image rounded-md border border-gray-200 dark:border-gray-700 max-w-full h-auto">
          </div>
        </li>
      </ol>


    </div>
  </div>

  <div class="form-section flex flex-col">
    <div class="p-6 pb-2">
      <div class="flex items-center gap-4">
        <div class="w-12 h-12 rounded-xl bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
          <mat-icon class="icon-size-6 text-primary-600 dark:text-primary-400"
            [svgIcon]="'tabler_outline:file-certificate'"></mat-icon>
        </div>
        <div>
          <h2 class="text-xl font-bold text-gray-900 dark:text-white">
            {{ data.hasCertificate ? 'Zmień certyfikat KSeF' : 'Dodaj certyfikat KSeF' }}
          </h2>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">NIP: {{ data.nip || 'nie określono' }}</p>
        </div>
      </div>
    </div>

    <div class="px-6 py-4 flex-1" [formGroup]="form">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Certyfikat (.crt)</label>
        <label class="file-picker group cursor-pointer">
          <input class="hidden" type="file" accept=".crt" (change)="onCertificateFileSelected($event)">
          <div class="file-picker-inner">
            <div class="file-picker-icon bg-blue-100 dark:bg-blue-900/30">
              <mat-icon class="icon-size-4 text-blue-600 dark:text-blue-400"
                [svgIcon]="'tabler_outline:upload'"></mat-icon>
            </div>
            <div class="min-w-0">
              <p class="text-sm font-medium text-gray-900 dark:text-white">Wybierz plik certyfikatu</p>
              <p class="text-xs text-gray-500 dark:text-gray-400">Dozwolone rozszerzenie: .crt</p>
            </div>
            <span class="file-picker-cta">Przegladaj</span>
          </div>
        </label>
        <div *ngIf="certificateFileName"
          class="mt-2 rounded-lg border border-emerald-200 dark:border-emerald-900/50 bg-emerald-50 dark:bg-emerald-950/20 p-3">
          <div class="flex items-center gap-2">
            <mat-icon class="icon-size-4 text-emerald-600 dark:text-emerald-400"
              [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
            <p class="text-sm text-emerald-700 dark:text-emerald-300 font-medium">Plik certyfikatu został wybrany</p>
          </div>
          <p class="text-xs text-emerald-700/80 dark:text-emerald-300/80 mt-1">{{ certificateFileName }}</p>
        </div>
        <p *ngIf="certificateFileError" class="text-xs mt-1 text-red-600 dark:text-red-400">{{ certificateFileError }}
        </p>
      </div>

      <div class="mt-4 mb-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Klucz prywatny (.key)</label>
        <label class="file-picker group cursor-pointer">
          <input class="hidden" type="file" accept=".key" (change)="onPrivateKeyFileSelected($event)">
          <div class="file-picker-inner">
            <div class="file-picker-icon bg-indigo-100 dark:bg-indigo-900/30">
              <mat-icon class="icon-size-4 text-indigo-600 dark:text-indigo-400"
                [svgIcon]="'tabler_outline:key'"></mat-icon>
            </div>
            <div class="min-w-0">
              <p class="text-sm font-medium text-gray-900 dark:text-white">Wybierz plik klucza prywatnego</p>
              <p class="text-xs text-gray-500 dark:text-gray-400">Dozwolone rozszerzenie: .key</p>
            </div>
            <span class="file-picker-cta">Przegladaj</span>
          </div>
        </label>
        <div *ngIf="privateKeyFileName"
          class="mt-2 rounded-lg border border-emerald-200 dark:border-emerald-900/50 bg-emerald-50 dark:bg-emerald-950/20 p-3">
          <div class="flex items-center gap-2">
            <mat-icon class="icon-size-4 text-emerald-600 dark:text-emerald-400"
              [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
            <p class="text-sm text-emerald-700 dark:text-emerald-300 font-medium">Plik klucza prywatnego został wybrany
            </p>
          </div>
          <p class="text-xs text-emerald-700/80 dark:text-emerald-300/80 mt-1">{{ privateKeyFileName }}</p>
        </div>
        <p *ngIf="privateKeyFileError" class="text-xs mt-1 text-red-600 dark:text-red-400">{{ privateKeyFileError }}</p>
      </div>

      <div *ngIf="!certificateFileName || !privateKeyFileName"
        class="p-3 rounded-lg border border-amber-200 dark:border-amber-900/50 bg-amber-50 dark:bg-amber-950/20">
        <p class="text-xs text-amber-700 dark:text-amber-300">Wybierz oba pliki, aby aktywować zapis konfiguracji.</p>
      </div>

      <mat-form-field class="w-full mt-4">
        <mat-label>Hasło klucza prywatnego</mat-label>
        <input matInput [type]="showPassphrase ? 'text' : 'password'" formControlName="privateKeyPassphrase"
          autocomplete="new-password" data-lpignore="true" data-1p-ignore>
        <mat-hint>Przepisz 15 znakowe hasło, które utworzyłeś w KSeF dla tego klucza prywatnego.</mat-hint>
        <button mat-icon-button matSuffix type="button" (click)="showPassphrase = !showPassphrase" tabindex="-1">
          <mat-icon class="icon-size-4"
            [svgIcon]="showPassphrase ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
        </button>
        <mat-error *ngIf="form.controls.privateKeyPassphrase.hasError('required')">Hasło klucza jest
          wymagane.</mat-error>
        <mat-error *ngIf="form.controls.privateKeyPassphrase.hasError('ksefPassword')">Nieprawidłowe hasło klucza
          prywatnego z KSeF.</mat-error>
      </mat-form-field>

      <div class="mt-6 mb-4 text-xs text-gray-500 dark:text-gray-400 p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg">
        <p class="font-semibold mb-1 text-gray-700 dark:text-gray-300">Wymagania KSeF:</p>
        <p>Musi zawierać minimum:</p>
        <ul class="list-disc pl-4 mb-2 space-y-0.5 transition-colors duration-300">
          <li
            [ngClass]="{'text-green-600 dark:text-green-400 font-medium': hasMinLength, 'text-gray-500 dark:text-gray-400': !hasMinLength}">
            15 znaków</li>
          <li
            [ngClass]="{'text-green-600 dark:text-green-400 font-medium': hasUpperCase, 'text-gray-500 dark:text-gray-400': !hasUpperCase}">
            1 wielką literę</li>
          <li
            [ngClass]="{'text-green-600 dark:text-green-400 font-medium': hasLowerCase, 'text-gray-500 dark:text-gray-400': !hasLowerCase}">
            1 małą literę</li>
          <li
            [ngClass]="{'text-green-600 dark:text-green-400 font-medium': hasNumber, 'text-gray-500 dark:text-gray-400': !hasNumber}">
            1 cyfrę</li>
          <li
            [ngClass]="{'text-green-600 dark:text-green-400 font-medium': hasSpecialChar, 'text-gray-500 dark:text-gray-400': !hasSpecialChar}">
            1 znak specjalny: !&#64;#$%^&*()-_=+</li>
        </ul>
        <p>Nie może zawierać:</p>
        <ul class="list-disc pl-4 space-y-0.5">
          <li>więcej niż 32 znaków</li>
          <li>polskich znaków</li>
          <li>innych znaków specjalnych</li>
        </ul>
      </div>

    </div>

    <div class="px-6 pb-6 flex justify-end gap-3 border-t border-gray-200 dark:border-gray-700 pt-4 mt-auto">
      <button mat-stroked-button (click)="cancel()">Anuluj</button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="form.invalid">
        <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:check'"></mat-icon>
        <span class="ml-1">Zapisz certyfikat</span>
      </button>
    </div>
  </div>
</div>
